import { useCallback, useState } from 'react';

import ConfirmationDialog from '@sayyesschool/frontend/components/confirmation-dialog';
import FormDialog from '@sayyesschool/frontend/components/form-dialog';
import PageSection from '@sayyesschool/frontend/components/page-section';
import { useBoolean } from '@sayyesschool/frontend/hooks/state';

import LessonForm from '../lesson-form';
import LessonsList from '../lessons-list';

export default function UnitLessons({ unit, onCreate, onDelete, onReorder }) {
    const [lesson, setLesson] = useState();
    const [isFormDialogOpen, toggleFormDialogOpen] = useBoolean(false);
    const [isConfirmationDialogOpen, toggleConfirmationDialogOpen] = useBoolean(false);

    const handleCreate = useCallback(data => {
        return onCreate(data).finally(() => toggleFormDialogOpen(false));
    }, [onCreate, toggleFormDialogOpen]);

    const handleDelete = useCallback(() => {
        return onDelete(lesson).finally(() => {
            toggleConfirmationDialogOpen(false);
            setLesson(undefined);
        });
    }, [lesson, onDelete, toggleConfirmationDialogOpen]);

    const handleReorderLessons = useCallback((index, dir) => {
        const lessons = unit._lessons.slice();
        const lesson = lessons[index];
        const otherLesson = lessons[index + dir];

        lessons[index + dir] = lesson;
        lessons[index] = otherLesson;

        onReorder({ _lessons: lessons });
    }, [unit, onReorder]);

    const handleDeleteRequest = useCallback(lesson => {
        setLesson(lesson);
        toggleConfirmationDialogOpen(true);
    }, [toggleConfirmationDialogOpen]);

    return (
        <PageSection
            className="UnitLessons"
            title="Уроки"
            actions={[{
                key: 'add',
                icon: 'add',
                title: 'Добавить урок',
                onClick: toggleFormDialogOpen
            }]}
            compact
        >
            <LessonsList
                lessons={unit.lessons}
                onReorder={handleReorderLessons}
                onDelete={handleDeleteRequest}
            />

            <FormDialog
                title="Новый урок"
                open={isFormDialogOpen}
                onClose={toggleFormDialogOpen}
            >
                <LessonForm
                    id="lesson-form"
                    onSubmit={handleCreate}
                />
            </FormDialog>

            <ConfirmationDialog
                title="Удалить урок?"
                message={unit && `Урок "${unit.title}" будет удален без возможности восстановления.`}
                open={isConfirmationDialogOpen}
                onConfirm={handleDelete}
                onClose={toggleConfirmationDialogOpen}
            />
        </PageSection>
    );
}